import { useAppSelector } from "@/redux/hooks";
import { useCheckoutUI } from "../CheckoutUIProvider";
import { getAllCarts } from "@/redux/selectors";
import isEqual from "lodash/isEqual";
import { UserRetailerShoppingCart } from "../../../types";

type ShoppingCartWithItems = Partial<UserRetailerShoppingCart> &
  Pick<Required<UserRetailerShoppingCart>, "items" | "retailerId">;

export const useCheckoutCartInfo = () => {
  const [state] = useCheckoutUI();
  const { checkoutIntent } = state.context;

  const carts = useAppSelector(getAllCarts, isEqual);
  const cartToShow =
    carts.length > 0
      ? carts.reduce(
          (prev: ShoppingCartWithItems, current: ShoppingCartWithItems) =>
            prev.items.length > current.items.length ? prev : current
        )
      : ({ items: [], retailerId: 0 } as ShoppingCartWithItems);

  let items: any[] = [];
  let subtotal = 0;
  let estimatedShipping = 0;
  let estimatedTax = 0;
  let amountToCharge = 0;
  let deliveryEstimate = checkoutIntent?.shippingOptions?.[0]?.deliveryEstimate;
  let source: "checkoutIntent" | "cart" = "checkoutIntent";

  if (checkoutIntent?.estimatedOrderSummary) {
    ({
      estimatedOrderSummary: {
        subtotal,
        shippingFees: estimatedShipping,
        tax: estimatedTax,
        total: amountToCharge,
      },
    } = checkoutIntent);

    if (checkoutIntent?.items) {
      items = checkoutIntent?.items;
    }
  } else if (cartToShow) {
    items = cartToShow.items;
    subtotal = cartToShow.items.reduce(
      (acc, item) => acc + item.retailPrice * item.quantity,
      0
    );
    amountToCharge = subtotal;
    source = "cart";
  }

  return {
    subtotal,
    estimatedShipping,
    estimatedTax,
    amountToCharge,
    items,
    deliveryEstimate,
    source,
  };
};
